import { EmptyState } from '@cinesend/ui-kit'
import DataTable from '../../components/data_table'
import React from 'react'
import { useQuery } from '@tanstack/react-query'
import AirlineValidatorParams from './components/airline_validator_params'
import useTableFilters from '../../hooks/use_table_filters'

// list of airlines and their validators configs
const AirlineSpecificValidatorsTable = () => {
  const { data: airlines, isLoading: isAirlinesLoading, error: airlinesError } = useQuery(['airlines'])

  const filteringOptions = [
    {
      label: 'Airline',
      key: 'airline',
      type: 'checkboxes',
      options: airlines?.map((airline) => ({ label: airline.name, key: airline.id, value: airline.name })) || null,
    },
  ]
  const { queryString, searching, sorting, filtering, pagination } = useTableFilters({
    filteringOptions,
    enableSearch: true,
  })
  const { data: validators, error, isLoading, refetch } = useQuery([`validator-airline-config`, queryString])

  const getParameters = (data) => {
    return (
      <AirlineValidatorParams
        key={`params-${data.validator_id}-${data.airline_id}`}
        name={data.validator_name}
        data={data}
      />
    )
  }

  const columns = [
    { key: 'airline', header: 'Airline', render: (data) => data.airline_name },
    { key: 'validators', header: 'Validators', render: (data) => data.validator_name },
    { key: 'value', header: 'Value', render: (data, index) => getParameters(data) },
  ]

  return (
    <DataTable
      caption='Airline specific validators'
      columns={columns}
      rows={validators?.data ?? []}
      isLoading={isLoading}
      error={error}
      onRetry={refetch}
      empty={<EmptyState title='No Airline Specific Validators found!' detail='Create a new Airline to begin.' />}
      sorting={sorting}
      filtering={filtering}
      searching={searching}
      pagination={pagination}
      totalRows={validators?.meta.total ?? 0}
    />
  )
}

export default AirlineSpecificValidatorsTable
